// extracted by mini-css-extract-plugin
var _1 = "edv1G";
export { _1 as "form" }
